import React from "react";
import { Container, Row } from "react-bootstrap";

export default function DisputePageTitle({ title, subtitle }) {
  return (
    <section className="pt-[160px] lg:pt-[140px] pb-[50px] overflow-hidden lg:py-[100px] sm:py-[40px] sm:pt-[40px] md:py-[70px]  sm:h-[400px] xs:h-auto bg-dark">
      <Container>
        <Row>
          <Container>
            <div className="text-[40px] leading-[95px] text-[#ef8d23] font-bold uppercase tracking-[-1px] xl:tracking-[-1px] lg:text-[45px] md:text-[45px] md:leading-[45px] sm:text-[25px] sm:leading-[35px]">
              <span className="mr-2">{title}</span>
              {subtitle &&
                <span className="text-[30px] text-white tracking-[-1px] ml-5 ">
                {" "}{subtitle}
              </span>
              }
            </div>
          </Container>
        </Row>
      </Container>
    </section>
  );
}
